module.exports = __webpack_public_path__ + "img/account-icon.4719c9a6.svg";